export enum SortKeyName {
    SHIPMENT_NUMBER = "shipmentNumber",
}

export enum SortKeyDirectionName {
    Ascending = "asc",
    Descending = "desc",
}
